import(/* webpackMode: "eager" */ "/home/runner/work/erp_accelerator/erp_accelerator/frontend/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/erp_accelerator/erp_accelerator/frontend/components/Common/LoadingBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BannerProvider"] */ "/home/runner/work/erp_accelerator/erp_accelerator/frontend/components/Feedback/BannerProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/erp_accelerator/erp_accelerator/frontend/components/Feedback/GlobalErrorCatcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/erp_accelerator/erp_accelerator/frontend/components/Feedback/GlobalModalHost.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/erp_accelerator/erp_accelerator/frontend/components/Feedback/GlobalSuccessListener.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/runner/work/erp_accelerator/erp_accelerator/frontend/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/runner/work/erp_accelerator/erp_accelerator/frontend/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/home/runner/work/erp_accelerator/erp_accelerator/frontend/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApiProvider","useApi","useApiContext"] */ "/home/runner/work/erp_accelerator/erp_accelerator/frontend/contexts/ApiContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AudioPlayerProvider"] */ "/home/runner/work/erp_accelerator/erp_accelerator/frontend/contexts/AudioPlayerContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/runner/work/erp_accelerator/erp_accelerator/frontend/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/runner/work/erp_accelerator/erp_accelerator/frontend/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectProvider"] */ "/home/runner/work/erp_accelerator/erp_accelerator/frontend/contexts/ProjectContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/erp_accelerator/erp_accelerator/frontend/styles/nprogress.css");
